import { render, staticRenderFns } from "./w-modal.vue?vue&type=template&id=110bc890"
import script from "./w-modal.vue?vue&type=script&lang=ts"
export * from "./w-modal.vue?vue&type=script&lang=ts"
import style0 from "./w-modal.vue?vue&type=style&index=0&id=110bc890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports